module.exports = __webpack_public_path__ + "img/OnePathLife.a5f2e473.jpg";